import React from "react"
import { useTranslation } from "react-i18next"
import { Paper, Grid, Typography, styled } from "@mui/material"

import { colors } from "theme"
import Button from "components/ui/Button"

type Props = {
  code: number
  light: boolean
  onCancel: () => void
}

const CodeComponent = ({
  code,
  light = false,
  onCancel,
  ...restProps
}: Props) => {
  const { t } = useTranslation()

  return (
    <Card
      elevation={0}
      sx={{
        background: light ? colors.white : colors.ghostWhite,
      }}
      {...restProps}
    >
      <Container
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Typography component="span" variant="body1">
          {t("verification.title")}
        </Typography>
        <Code variant="h1">{code}</Code>
        <Typography component="span" variant="body1">
          {t("verification.message")}
        </Typography>

        <Cancel onClick={onCancel}>{t("common.cancel")}</Cancel>
      </Container>
    </Card>
  )
}

CodeComponent.defaultProps = {
  light: false,
}

export default CodeComponent

const Card = styled(Paper)(({ theme }) => ({
  borderRadius: "17px",
  marginBottom: "38px",
  padding: "41px",
  position: "relative",
  zIndex: 100,
  [theme.breakpoints.down("md")]: {
    margin: 0,
    padding: "31px",
  },
}))

const Container = styled(Grid)(() => ({
  margin: "0 auto",
  maxWidth: "250px",
  textAlign: "center",
}))

const Code = styled(Typography)(({ theme }) => ({
  fontSize: "3rem",
  fontWeight: "400",
  margin: "48px 0",
  [theme.breakpoints.down("md")]: {
    margin: "24px 0",
  },
}))

const Cancel = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  background: "transparent",
  fontSize: "0.875rem",
  fontWeight: "500",
  height: "16px",
  lineHeight: "15px",
  margin: "41px 0 0 0",
  maxWidth: "86px",
  padding: "0",
  textDecoration: "none",
}))
